import React, { useState, useEffect } from "react";
import styles from "./SubCotizacion.module.scss";
import { connect } from "react-redux";
import {
  openMainModal,
  setPostulationProject,
  getProjectQuestions,
  setOpenMainId,
} from "../../../store/actions/profileActions";
import SubCotizacionDetailsInfo from "./SubCotizacionDetailsInfo";


const Subproject = ({
  onClick,
  opened,
  handlePostulation,
  allowOpen,
  isPostulating,
  updatePortfolio,
  formik,
  fromPage,
  handleClose,
  defaultDropdownOpen,
  newImage,
  isVisualizer,
  isPortfolio,
  isProject,
  setOpenMainId,
  openMainId,
  openMainModal,
  item,
  isPostulation,
  setPostulationProject,
  getProjectQuestions,
  displayInfo,
  type,
  setOpenItem,
  openItem,
  isAllowed,
  dropdownOpen,
  setPreparePostulation,  
  setDropdownOpen,
  dat,
  ...props
}) => {


  let { name, description, startDate = "", endDate = "", zone, id } = item;

  return (
    <div
      className={
        !allowOpen
          ? `${styles.containerClosed} ${
              isPostulation || isProject ? styles.isPostulationClose : ""
            }`
          : `${styles.container} ${
              isPostulation || isProject ? styles.isPostulation : ""
            }`
      }
    >
        <SubCotizacionDetailsInfo
          type={type}
          opened={opened}
          onClick={onClick}
          allowOpen={allowOpen}
          isPostulation={isPostulation}
          isProject={isProject}
          dropdownOpen={dropdownOpen}
          setDropdownOpen={setDropdownOpen}
          name={name}
          zone={zone}
          startDate={startDate}
          endDate={endDate}
          description={description}
          item={item}
          id={id}
          displayInfo={displayInfo}
          isPostulating={isPostulating}
          handleCose={handleClose}
          newImage={newImage}
          updatePortfolio={updatePortfolio}
          formik={formik}
          userData={props.userData}
          setPreparePostulation={setPreparePostulation}
          isAllowed={isAllowed}

          {...props}
        />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    onClick: ownProps.onClick,
    userData: state.general.userData,
    openMainId: state.profile.openMainId,
    displayInfo: state.profile.displayInfo,
    allowOpen: ownProps.allowOpen,
  };
};
export default connect(mapStateToProps, {
  openMainModal,
  setPostulationProject,
  getProjectQuestions,
  setOpenMainId,
})(Subproject);